(function(){
"use strict";
var rm=window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function reveal(){
  var items=[].slice.call(document.querySelectorAll(".ci-rv:not(.is-in)"));
  if(!items.length)return;
  if(!("IntersectionObserver" in window)){items.forEach(function(n){n.classList.add("is-in")});return}
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("is-in");io.unobserve(e.target)}})
  },{threshold:.1,rootMargin:"0px 0px -6% 0px"});
  items.forEach(function(n){io.observe(n)});
}

function parallax(){
  var hero=document.querySelector(".ci-hero");
  if(!hero||rm)return;
  if(!window.matchMedia("(hover:hover) and (pointer:fine)").matches)return;
  var ls=[].slice.call(hero.querySelectorAll("[data-depth]"));
  if(!ls.length)return;
  var tx=0,ty=0,cx=0,cy=0,raf=0;
  function loop(){
    cx+=(tx-cx)*.08; cy+=(ty-cy)*.08;
    for(var i=0;i<ls.length;i++){
      var d=+ls[i].getAttribute("data-depth")||0;
      ls[i].style.translate=(cx*d).toFixed(1)+"px "+(cy*d).toFixed(1)+"px";
    }
    if(Math.abs(tx-cx)>.001||Math.abs(ty-cy)>.001){raf=requestAnimationFrame(loop)}else{raf=0}
  }
  window.addEventListener("pointermove",function(e){
    var r=hero.getBoundingClientRect();
    tx=Math.max(-1,Math.min(1,(e.clientX-(r.left+r.width/2))/r.width*2));
    ty=Math.max(-1,Math.min(1,(e.clientY-(r.top+r.height/2))/r.height*2));
    if(!raf)raf=requestAnimationFrame(loop);
  },{passive:true});
}

function heroDrift(){
  var stage=document.querySelector(".ci-hero__stage");
  if(!stage||rm)return;
  var vh=window.innerHeight,ticking=false;
  function run(){
    ticking=false;
    var y=window.pageYOffset;
    if(y<vh*1.15){
      stage.style.transform="translate3d(0,"+(y*.11).toFixed(1)+"px,0)";
      stage.style.opacity=(1-y/(vh*.9)).toFixed(3);
    }
  }
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(run)}},{passive:true});
  window.addEventListener("resize",function(){vh=window.innerHeight},{passive:true});
  run();
}

function stickyBar(){
  var bar=document.querySelector(".ci-stickybar");
  if(!bar)return;
  var anchor=document.querySelector("[data-ci-buy]");
  var vh=window.innerHeight,ticking=false,shown=false;
  function run(){
    ticking=false;
    var on=shown;
    if(anchor){
      var r=anchor.getBoundingClientRect();
      if(!shown&&r.bottom<-20)on=true;
      if(shown&&r.bottom>40)on=false;
    }else{
      var y=window.pageYOffset;
      if(!shown&&y>vh*.9)on=true;
      if(shown&&y<vh*.7)on=false;
    }
    if(on!==shown){shown=on;bar.classList.toggle("is-on",on)}
  }
  window.addEventListener("scroll",function(){if(!ticking){ticking=true;requestAnimationFrame(run)}},{passive:true});
  window.addEventListener("resize",function(){vh=window.innerHeight;run()},{passive:true});
  run();
}

function anchors(){
  document.addEventListener("click",function(e){
    var a=e.target.closest?e.target.closest('a[href^="#"]:not([href="#"])'):null;
    if(!a)return;
    var t=null;
    try{t=document.querySelector(a.getAttribute("href"))}catch(err){return}
    if(!t)return;
    e.preventDefault();
    t.scrollIntoView({behavior:rm?"auto":"smooth",block:"start"});
  });
}

function gallery(){
  var root=document.querySelector("[data-ci-gallery]");
  if(!root)return;
  var main=root.querySelector("[data-ci-gallery-main]");
  if(!main)return;
  root.addEventListener("click",function(e){
    var b=e.target.closest?e.target.closest("[data-ci-thumb]"):null;
    if(!b)return;
    var src=b.getAttribute("data-src"),srcset=b.getAttribute("data-srcset");
    if(src)main.src=src;
    if(srcset)main.srcset=srcset;
    var all=root.querySelectorAll("[data-ci-thumb]");
    for(var i=0;i<all.length;i++)all[i].setAttribute("aria-current","false");
    b.setAttribute("aria-current","true");
  });
}

function init(){
  reveal();parallax();heroDrift();stickyBar();anchors();gallery();
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init)}else{init()}
document.addEventListener("shopify:section:load",init);
})();

(function(){
  var FALLBACK=15;
  function limit(){var n=parseInt(window.ciMaxQty,10);return n>0?n:FALLBACK}
  function fieldOf(el){
    var w=el.closest?el.closest(".js-qty__wrapper"):null;
    return w?w.querySelector(".js-qty__num"):null;
  }
  function note(w,max){
    if(!w)return;
    var host=w.parentNode;
    if(!host)return;
    var n=host.querySelector("[data-qty-limit]");
    if(!n){
      n=document.createElement("div");
      n.className="ci-qtynote ci-qtynote--limit";
      n.setAttribute("data-qty-limit","");
      host.appendChild(n);
    }
    n.textContent="Maximal "+max+" pro Bestellung";
  }
  document.addEventListener("click",function(e){
    var t=e.target;
    var btn=t&&t.closest?t.closest(".js-qty__adjust--plus"):null;
    if(!btn)return;
    var inp=fieldOf(btn);
    if(!inp)return;
    var max=limit();
    if(parseInt(inp.value,10)>=max){
      e.preventDefault();
      e.stopPropagation();
      inp.value=max;
      note(btn.closest(".js-qty__wrapper"),max);
    }
  },true);
  document.addEventListener("change",function(e){
    var t=e.target;
    if(!t||!t.classList||!t.classList.contains("js-qty__num"))return;
    var max=limit();
    var v=parseInt(t.value,10);
    if(!isNaN(v)&&v>max){
      t.value=max;
      note(t.closest(".js-qty__wrapper"),max);
    }
  },true);
})();